import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  model,
  resource,
  signal,
} from '@angular/core';
import { SessionService } from '@core/services/session.service';
import { SocketService } from '@core/services/socket.service';
import { User } from '@core/interfaces/user.interface';
import {
  NgpTabset,
  NgpTabList,
  NgpTabButton,
  NgpTabPanel,
} from 'ng-primitives/tabs';
import { KeyValuePipe } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TableComponent } from '@core/components/table/table.component';
import { PaginationState } from '@tanstack/angular-table';
import { UserHistoryService } from '../services/user-history.service';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  gamesHistorySettings,
  gamesHistoryStore,
} from '../configs/games-history-store.config';

@Component({
  selector: 'app-user-games-history',
  imports: [
    NgpTabset,
    NgpTabList,
    NgpTabButton,
    NgpTabPanel,
    KeyValuePipe,
    NgScrollbarModule,
    TableComponent,
    SvgIconComponent,
  ],
  templateUrl: './user-games-history.component.html',
  styleUrl: './user-games-history.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UserGamesHistoryComponent {
  private socketService = inject(SocketService);
  public session = inject(SessionService);
  public userHistoryService = inject(UserHistoryService);

  user = input.required<User>();
  active = input<boolean>(false);
  readonly pagination = model<PaginationState>({
    pageIndex: 0,
    pageSize: 14,
  });
  tabs = signal(gamesHistorySettings);
  readonly selectedTab =
    signal<keyof typeof gamesHistorySettings>('Case Battles');

  storeResource = resource({
    params: () => {
      if (!this.active()) return undefined;
      return {
        endpoint: this.tabs()[this.selectedTab()].endpoint,
        steamid: this.user().steamid,
      };
    },
    loader: async ({ params }) => {
      if (!params) return undefined;
      const data = await this.socketService.emit(params.endpoint, {
        steamid: params.steamid,
        potid: 1,
      });
      return data;
    },
  });

  store = computed(() => {
    return {
      ...gamesHistoryStore,
      [this.selectedTab()]: this.storeResource.value(),
    };
  });

  selectedTabResetEffect = effect(() => {
    if (this.selectedTab()) {
      this.pagination.update((prev) => ({
        pageSize: prev.pageSize,
        pageIndex: 0,
      }));
    }
  });
}
